<template>
  <transition name="fade">
    <div v-if="active" class="fixed inset-0 z-50 flex items-center justify-center p-8 xl:p-16">
      <div class="absolute inset-0 bg-white bg-opacity-75" @click="$emit('update:active', false)" />
      <div class="absolute top-0 right-0 p-8">
        <button class="w-5 h-5 bg-white rounded-full" @click="$emit('update:active', false)">
          <x-icon />
        </button>
      </div>
      <slot />
    </div>
  </transition>
</template>

<script>
import { XIcon } from '@zhuowenli/vue-feather-icons'

export default {
  name: 'Modal',
  components: {
    XIcon,
  },
  props: {
    active: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ['update:active'],
}
</script>

<style>

</style>
